import React, { FC, ReactNode } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'
import { TOUCH_DEVICE_OPTIONS } from 'constants/dnd'
import { hasTouchScreen } from 'lib/judge'
import { DndPreview } from './index'

type Props = {
  children: ReactNode
}

const DndWrapper: FC<Props> = (props) => {
  const { children } = props
  return (
    <DndProvider
      backend={hasTouchScreen() ? TouchBackend : HTML5Backend}
      options={hasTouchScreen() ? TOUCH_DEVICE_OPTIONS : {}}
    >
      {children}
      {hasTouchScreen() ? <DndPreview /> : <></>}
    </DndProvider>
  )
}

export default DndWrapper
